import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ApiKey } from '../api-key.model';

export enum ApiKeyActionTypes {
  UpsertApiKey = '[ApiKey] Upsert Api Key',
  GetApiKeys = '[ApiKey] Get Api Key',
  GetApiKeysFail = '[ApiKey] Get ApiKey Fail',
  AddApiKey = '[ApiKey] Add Api Key',
  AddApiKeySuccess = '[ApiKey] Add Api Key Success',
  AddApiKeyFail = '[ApiKey] Add Api Key Fail',
  UpdateApiKey = '[ApiKey] Update Api Key',
  UpdateApiKeySuccess = '[ApiKey] Update Api Key Success',
  UpdateApiKeyFail = '[ApiKey] Update Api Key Fail',
  DeleteApiKey = '[ApiKey] Delete Api Key',
  DeleteApiKeySuccess = '[ApiKey] Delete Api Key Success',
  DeleteApiKeyFail = '[ApiKey] Delete Api Key Fail',
  UpsertApiKeyUsage = '[ApiKey] Upsert Api Key Usage',
  GetApiKeyUsage = '[ApiKey] Get Api Key Usage',
  GetApiKeyUsageFail = '[ApiKey] Get Api Key Usage Fail',
}

export class GetApiKeys implements Action {
  readonly type = ApiKeyActionTypes.GetApiKeys;

  constructor(public payload: any = null) {}
}
export class UpsertApiKey implements Action {
  readonly type = ApiKeyActionTypes.UpsertApiKey;

  constructor(public payload: any) {}
}
export class GetApiKeysFail implements Action {
  readonly type = ApiKeyActionTypes.GetApiKeysFail;

  constructor(public payload: any = null) {}
}

export class AddApiKey implements Action {
  readonly type = ApiKeyActionTypes.AddApiKey;

  constructor(public payload: any = null) {}
}

export class AddApiKeySuccess implements Action {
  readonly type = ApiKeyActionTypes.AddApiKeySuccess;

  constructor(public payload: any = null) {
  }
}

export class AddApiKeyFail implements Action {
  readonly type = ApiKeyActionTypes.AddApiKeyFail;

  constructor(public payload: any = null) {
  }
}

export class UpdateApiKey implements Action {
  readonly type = ApiKeyActionTypes.UpdateApiKey;

  constructor(public payload: any = null) {}
}

export class UpdateApiKeySuccess implements Action {
  readonly type = ApiKeyActionTypes.UpdateApiKeySuccess;

  constructor(public payload: any = null) {
  }
}

export class UpdateApiKeyFail implements Action {
  readonly type = ApiKeyActionTypes.UpdateApiKeyFail;

  constructor(public payload: any = null) {
  }
}

export class DeleteApiKey implements Action {
  readonly type = ApiKeyActionTypes.DeleteApiKey;

  constructor(public payload: any = null) {}
}

export class DeleteApiKeySuccess implements Action {
  readonly type = ApiKeyActionTypes.DeleteApiKeySuccess;

  constructor(public payload: any = null) {
  }
}

export class DeleteApiKeyFail implements Action {
  readonly type = ApiKeyActionTypes.DeleteApiKeyFail;

  constructor(public payload: any = null) {
  }
}

export class GetApiKeyUsage implements Action {
  readonly type = ApiKeyActionTypes.GetApiKeyUsage;

  constructor(public payload: any) {}
}

export class UpsertApiKeyUsage implements Action {
  readonly type = ApiKeyActionTypes.UpsertApiKeyUsage;

  constructor(public payload: any = null) {}
}

export class GetApiKeyUsageFail implements Action {
  readonly type = ApiKeyActionTypes.GetApiKeyUsageFail;

  constructor(public payload: any = null) {}
}



export type ApiKeyActions =
UpsertApiKey
 | GetApiKeys
 | GetApiKeysFail
 | AddApiKey
 | AddApiKeyFail
 | AddApiKeySuccess
 | UpdateApiKey
 | UpdateApiKeyFail
 | UpdateApiKeySuccess
 | DeleteApiKey
 | DeleteApiKeyFail
 | DeleteApiKeySuccess
 | GetApiKeyUsage
 | UpsertApiKeyUsage
 | GetApiKeyUsageFail
